var lintGazetteer = require('./lint-gazetteer.js');

module.exports = {
  lintGazetteer: lintGazetteer
};